import { Component, EventEmitter, Input, Output } from '@angular/core';
import { KfiApplicant } from '../../models/kfi-applicant.model';
import { ReferenceDataContextualHelps } from './../../../../lib/constants/reference-data-contextual-helps';
import { ReferenceDataLabels } from './../../../../lib/constants/reference-data-labels';

@Component({
  selector: 'boi-kfi-applicant-control',
  templateUrl: './kfi-applicant-control.component.html',
  styleUrls: ['./kfi-applicant-control.component.scss']
})
export class KfiApplicantControlComponent {
  @Input() public kfiApplicants: Array<KfiApplicant>;
  @Input() public isReadOnly: boolean;

  @Output() public readonly updateApplicantsEvent = new EventEmitter<Array<KfiApplicant>>();

  public isDeleteApplicantDialogOpen: boolean;
  public selectedApplicantIndex: number;

  public referenceDataLabels = ReferenceDataLabels;
  public referenceDataContextualHelps = ReferenceDataContextualHelps;

  public openDeleteApplicantDialog(applicantIndex: number): void {
    this.selectedApplicantIndex = applicantIndex;
    this.isDeleteApplicantDialogOpen = true;
  }

  public addApplicant(): void {
    const newApplicant = new KfiApplicant();
    newApplicant.ApplicantOrder = this.kfiApplicants ? this.kfiApplicants.length + 1 : 1;
    this.kfiApplicants.push(newApplicant);
  }

  public deleteApplicant(applicantIndex: number): void {
    this.kfiApplicants.splice(applicantIndex, 1);
    this.updateApplicantsEvent.emit(this.kfiApplicants);
  }
}
